import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-i18n-guide-modal',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Adding a New Notification Type — i18n Checklist</h2>
    <mat-dialog-content>
      <p>
        After creating a notification type here, the Galaxy library's settings UI needs to know how to display it.
        Update these three files on the <code>master</code> branch before or alongside your notification type PR.
      </p>

      <h3>1. Add the type-to-key mapping</h3>
      <p>
        Open
        <a href="https://github.com/vendasta/galaxy/blob/master/libs/atlas/src/lib/notifications/settings/settings-form/notification-type-definitions.ts"
           target="_blank" rel="noopener">
          notification-type-definitions.ts
        </a>
        and add an entry for your new notification type ID:
      </p>
      <pre>
'your-notification-type-id': {{ '{' }}
  name: 'NOTIFICATIONS.TYPES.YOUR_NOTIFICATION_TYPE_ID.NAME',
  description: 'NOTIFICATIONS.TYPES.YOUR_NOTIFICATION_TYPE_ID.DESCRIPTION',
{{ '}' }},</pre>
      <p>
        The key is the <strong>exact notification type ID</strong> you configured (e.g.
        <code>sales-order-created</code>). The i18n key is that ID uppercased with hyphens replaced by underscores.
      </p>

      <h3>2. Add the translation strings</h3>
      <p>
        Open
        <a href="https://github.com/vendasta/galaxy/blob/master/libs/atlas/src/lib/languages/en_devel.json"
           target="_blank" rel="noopener">
          en_devel.json
        </a>
        and add your keys under <code>NOTIFICATIONS &gt; TYPES</code>:
      </p>
      <pre>
"YOUR_NOTIFICATION_TYPE_ID": {{ '{' }}
  "NAME": "Human-readable display name",
  "DESCRIPTION": "One sentence describing when this notification fires."
{{ '}' }}</pre>

      <h3>3. New category? (only if applicable)</h3>
      <p>
        If your notification belongs to a brand-new category that does not appear in the list yet, also:
      </p>
      <ol>
        <li>
          Add the category mapping to
          <a href="https://github.com/vendasta/galaxy/blob/master/libs/atlas/src/lib/notifications/settings/settings-form/category-key.pipe.ts"
             target="_blank" rel="noopener">
            category-key.pipe.ts
          </a>
          inside <code>CATEGORY_KEY_MAP</code>.
        </li>
        <li>
          Add the translated label to <code>en_devel.json</code> under
          <code>NOTIFICATIONS &gt; CATEGORIES</code>.
        </li>
      </ol>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./i18n-guide-modal.component.scss'],
})
export class I18nGuideModalComponent {}
